import { render, staticRenderFns } from "./CostIndex.vue?vue&type=template&id=0fd8b546"
import script from "./CostIndex.vue?vue&type=script&lang=js"
export * from "./CostIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports